import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CheckoutService } from '../stripe/checkout.service';

@Component({
    selector: 'convfact-add-coupon-dialog',
    templateUrl: './add-coupon-dialog.component.html',
    styleUrls: ['./add-coupon-dialog.component.css'],
    standalone: false
})
export class AddCouponDialogComponent {

  couponCode: string = '';
  isApplying: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddCouponDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private checkoutService: CheckoutService
  ) {
    this.couponCode = data && data.couponCode ? data.couponCode : '';
  }

  close(): void {
    this.dialogRef.close();
  }

  apply(): void {
    if (!this.couponCode || this.couponCode.trim() === '') {
      this.errorMessage = 'Introduce un código de cupón';
      return;
    }

    this.errorMessage = '';
    this.successMessage = '';
    this.isApplying = true;

    const promoCode = this.couponCode.trim().toUpperCase();

    this.checkoutService.applyCoupon(promoCode).then(result => {
      this.isApplying = false;

      if (result && result.success) {
        this.successMessage = '✅ ' + (result.message || 'Cupón aplicado correctamente');
        
        // Cerrar el diálogo después de un breve delay
        setTimeout(() => {
          this.dialogRef.close({ success: true, result: result });
        }, 1000);
      } else {
        this.errorMessage = this.getErrorMessage(result);
      }
    }).catch(error => {
      this.isApplying = false;
      this.errorMessage = 'No se ha podido aplicar el cupón. Inténtalo de nuevo.';
    });
  }

  private getErrorMessage(result: any): string {
    if (!result) {
      return 'Error al aplicar el cupón';
    }

    const errorCode = result.errorCode;
    const message = result.message;

    switch(errorCode) {
      case 'NO_STRIPE_CUSTOMER':
        return '❌ Tu cuenta no está vinculada a Stripe';
      case 'NO_SUBSCRIPTION':
        return '📦 No tienes una suscripción activa';
      case 'INVALID_CODE':
        return '🔍 El código no es válido o ha caducado';
      case 'INVALID_COUPON':
        return '❌ El cupón no es válido';
      case 'coupon_expired':
        return '🗓️ El cupón ha caducado';
      case 'resource_missing':
        return '🔍 El código no existe';
      default:
        return message || 'Error al aplicar el cupón';
    }
  }
}
